export const noteHeaders = [
  {
    name: 'When',
    value: 'date'
  },
  {
    name: 'What',
    value: 'type'
  },
  {
    name: 'Comments',
    value: 'comments'
  },
  {
    name: 'Start',
    value: 'date'
  },
  {
    name: 'Finish',
    value: 'finish'
  },
  {
    name: 'Time',
    value: 'timePassed'
  },
  // {
  //   name: 'Who',
  //   value: 'username'
  // }
]